import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'

interface Props {
  cols?: 1 | 2 | 3 | 4 | 5 | 6 | 12
  smCols?: 1 | 2 | 3 | 4 | 5 | 6 | 12
  mdCols?: 1 | 2 | 3 | 4 | 5 | 6 | 12
  lgCols?: 1 | 2 | 3 | 4 | 5 | 6 | 12
  xlCols?: 1 | 2 | 3 | 4 | 5 | 6 | 12
  gap?: 'sm' | 'md' | 'lg' | 'xl'
  customClass?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseGrid',
  props: {
    cols: { default: 1 },
    smCols: {},
    mdCols: {},
    lgCols: {},
    xlCols: {},
    gap: { default: 'md' },
    customClass: { default: '' }
  },
  setup(__props: any) {

const props = __props

const gridClasses = computed(() => {
  const baseClasses = ['grid']
  
  // Gap classes
  const gapClasses = {
    sm: 'gap-3',
    md: 'gap-6',
    lg: 'gap-8',
    xl: 'gap-12'
  }

  // Column classes
  const colClasses = {
    1: 'grid-cols-1',
    2: 'grid-cols-2',
    3: 'grid-cols-3',
    4: 'grid-cols-4',
    5: 'grid-cols-5',
    6: 'grid-cols-6',
    12: 'grid-cols-12'
  }

  const classes = [
    ...baseClasses,
    gapClasses[props.gap],
    colClasses[props.cols]
  ]

  // Responsive columns
  if (props.smCols) classes.push(`sm:${colClasses[props.smCols]}`)
  if (props.mdCols) classes.push(`md:${colClasses[props.mdCols]}`)
  if (props.lgCols) classes.push(`lg:${colClasses[props.lgCols]}`)
  if (props.xlCols) classes.push(`xl:${colClasses[props.xlCols]}`)

  if (props.customClass) classes.push(props.customClass)

  return classes
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(gridClasses.value)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})